//This one polls for images, use only in chat page!
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import RecipeSlidePanel from "./RecipeSlidePanel";
import { PhotoIcon } from "@heroicons/react/24/outline";
import { useRecipeWithImage } from "../hooks/useRecipeWithImage";
import { useAuth } from "../contexts/authContext";

export default function RecipeSummaryCard({ recipe, index }) {
  const [showPanel, setShowPanel] = useState(false);
  const { token, isLoggedIn } = useAuth();

  const navigate = useNavigate();

  const { recipe: liveRecipe, loading } = useRecipeWithImage(recipe._id, recipe);

  const servingCount = liveRecipe?.servings || 2;

  const handleGo = () => {
    if (servingCount > 0) {
      navigate(`/recipe/${index}?serve=${servingCount}`);
    }
  };

  if (!liveRecipe) {
    return (
      <div className="border p-4 rounded shadow bg-white h-full flex items-center justify-center text-gray-400">
        Loading recipe...
      </div>
    );
  }

  return (
    <>
      <div className="flex flex-col justify-between border p-4 rounded shadow bg-white h-full">
        <div>
          {/* IMAGE or PLACEHOLDER */}
          {liveRecipe.image ? (
            <img
              src={liveRecipe.image}
              alt={liveRecipe.name}
              className="w-full h-48 object-cover rounded-md mb-3 opacity-0 transition-opacity duration-700"
              onLoad={(e) => (e.currentTarget.style.opacity = 1)}
            />
          ) : (
            <div className="w-full h-48 flex items-center justify-center bg-gray-100 rounded-md animate-pulse mb-3">
              <PhotoIcon className="h-10 w-10 text-gray-400" />
            </div>
          )}

          <h2 className="text-lg font-bold">{liveRecipe.name}</h2>
          <p className="text-sm text-gray-600 italic mt-2">{liveRecipe.summary}</p>
          <div className="text-sm text-gray-600 mt-2">
            Prep: {liveRecipe.prepTime} | Cook: {liveRecipe.cookTime} | Serves: {liveRecipe.servings}
          </div>
        </div>

        <div className="flex gap-4 mt-4">
          <button
            onClick={() => setShowPanel(true)} 
            className="flex-1 bg-charcoal text-white text-sm px-3 py-1 rounded"
          >
            View Recipe
          </button>
        </div>
      </div>

      <RecipeSlidePanel
        isOpen={showPanel}
        onClose={() => setShowPanel(false)}
        recipe={liveRecipe}
      />
    </>
  );
}
